export default "__VITE_ASSET__BMD68kLS__"